import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { register } from '../utils/api';
import { motion } from 'framer-motion';

export default function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (password !== confirmPass) {
      setError("Passwords do not match.");
      return;
    }

    try {
      await register(email, password);
      setSuccess('Signup successful! Redirecting...');
      setTimeout(() => navigate('/login'), 1800);
    } catch (err) {
      setError('Signup failed. Email may already exist.');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.gradientBackground}></div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        style={styles.card}
      >
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          style={styles.title}
        >
          Join <span style={{ color: '#16f288' }}>NeoTyper</span>
        </motion.h1>

        <p style={styles.subtitle}>Sign up and unleash typing automation magic</p>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div style={styles.inputGroup}>
            <label>Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <label>Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <label>Retype Password</label>
            <input
              type="password"
              required
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
              style={{
                ...styles.input,
                borderColor:
                  confirmPass && confirmPass !== password ? 'salmon' : 'rgba(255,255,255,0.2)',
              }}
            />
          </div>

          <motion.button
            whileHover={{ scale: 1.05, boxShadow: '0 0 20px #16f28888' }}
            whileTap={{ scale: 0.95 }}
            type="submit"
            style={styles.button}
          >
            Create Account
          </motion.button>
        </form>

        {success && <p style={{ ...styles.message, color: 'lightgreen' }}>{success}</p>}
        {error && <p style={{ ...styles.message, color: 'salmon' }}>{error}</p>}

        <p style={styles.footerText}>
          Already have an account? <Link to="/login" style={styles.link}>Login here</Link>
        </p>
      </motion.div>
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    height: '100vh',
    width: '100%',
    fontFamily: "'Space Grotesk', sans-serif",
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  gradientBackground: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'radial-gradient(circle at 20% 30%, #0f0c29, #302b63, #24243e)',
    zIndex: -1,
  },
  card: {
    background: 'rgba(255,255,255,0.06)',
    padding: '50px 40px',
    borderRadius: '20px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
    backdropFilter: 'blur(14px)',
    border: '1px solid rgba(255,255,255,0.1)',
    width: '90%',
    maxWidth: 420,
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: '2.3rem',
    fontWeight: 700,
    marginBottom: 10,
    letterSpacing: 1.1,
  },
  subtitle: {
    color: '#aaa',
    fontSize: 14,
    marginBottom: 30,
  },
  inputGroup: {
    width: '100%',
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
    color: '#ccc',
  },
  input: {
    marginTop: 6,
    padding: '12px 16px',
    backgroundColor: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: 12,
    color: '#fff',
    fontSize: 15,
    outline: 'none',
    transition: 'all 0.3s ease',
  },
  button: {
    marginTop: 12,
    width: '100%',
    padding: '14px 0',
    borderRadius: 12,
    background: '#16f288',
    border: 'none',
    fontWeight: 600,
    color: '#000',
    fontSize: 16,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  link: {
    color: '#16f288',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
  message: {
    fontSize: 13,
    marginTop: 12,
    textAlign: 'center',
  },
  footerText: {
    marginTop: 24,
    fontSize: 13,
    color: '#aaa',
    textAlign: 'center',
  },
};
